const EXTERNAL_LINK_CLASS = 'u-external-link';
const LINK = '.c-content a';

class ExternalLinks {
	constructor() {
		const elements = [...document.querySelectorAll(LINK)];
		elements.forEach(element => {
			const href = element.attributes.href;

			if (typeof href != "undefined") {
				if (
					href.value.indexOf(document.location.hostname) < 0
					&& href.value.indexOf("tel:") < 0
					&& href.value.indexOf("mailto:") < 0
					&& href.value.indexOf("http") > -1
				) {
					element.setAttribute('aria-label', `${element.innerText || element.firstElementChild.getAttribute('alt')} (opent externe website in een nieuw tabblad)`)
					element.setAttribute('target', `_blank`)
					element.classList.add(EXTERNAL_LINK_CLASS);
				}
			}
		});

	}
}

export default ExternalLinks;